import { faPlus, faTrash } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useCallback, useEffect, useState } from "react";
import { ColumnDescription } from "react-bootstrap-table-next";
import { useForm } from "react-hook-form";
import Swal from "sweetalert2";
import Table from "../../../../../../Components/Table";
import {
    CadastrarOrdenacaoEtapaController,
    DeletarOrdenacaoEtapaController,
    ListarOrdenacaoEtapaController,
} from "../../../../../../Controllers/Automacao/Regua/GestaoDeRegua/GestaoDeReguaControllers";
import {
    IAcoesReguaEtapa,
    IOrdenacaoReguaEtapa,
} from "../../../../../../Interfaces/Automacao/Regua/GestaoDeRegua/GestaoDeReguaInterfaces";

interface IProps {
    row: IAcoesReguaEtapa;
}

interface IFormData {
    DS_CAMPO: string;
    NR_ORDEM: number;
    FL_ORDEM_CRESCENTE: boolean;
}

export default function ModalOrdemAcao(props: IProps) {
    const { register, handleSubmit, formState } = useForm();
    const [LstOrdenacaoEtapa, setLstOrdenacaoEtapa] = useState<
        Array<IOrdenacaoReguaEtapa>
    >([]);
    const [Loading, setLoading] = useState(false);

    const updateList = useCallback(() => {
        setLoading(true);
        ListarOrdenacaoEtapaController(props.row.ID_CASO_COBRANCA_REGUA_ETAPA)
            .then((res) => {
                setLstOrdenacaoEtapa(res);
                setLoading(false);
            })
            .catch(() => {
                setLoading(false);
            });
    }, [props.row.ID_CASO_COBRANCA_REGUA_ETAPA]);

    useEffect(() => {
        updateList();
    }, [updateList]);

    function handleFormSubmit(formData: IFormData) {
        CadastrarOrdenacaoEtapaController({
            DS_CAMPO: formData.DS_CAMPO,
            NR_ORDEM: formData.NR_ORDEM,
            FL_ORDEM_CRESCENTE: formData.FL_ORDEM_CRESCENTE,
            ID_CASO_COBRANCA_REGUA_ETAPA:
                props.row.ID_CASO_COBRANCA_REGUA_ETAPA,
        }).then(() => {
            updateList();
        });
    }

    const rowTable = (cell: any, row: IOrdenacaoReguaEtapa) => {
        return (
            <div
                className="card card-custom w-auto ml-auto wave wave-animate-slow wave-success border-bottom border-1 border-dark"
                key={row.ID_CASO_COBRANCA_REGUA_ETAPA_ORDENACAO}
            >
                <div className="card-body p-3">
                    <div className="d-flex align-itens-center justify-content-between mb-1">
                        <div>
                            <h1 className="font-weight-bolder font-size-normal">
                                <span className="h3 text-dark-75">
                                    {row.DS_CAMPO}
                                </span>
                            </h1>
                        </div>
                        <div></div>
                    </div>
                    <div className="d-flex flex-wrap align-itens-center justify-content-between mb-1">
                        <div className="d-flex flex-wrap  mr-1">
                            <div className="d-flex flex-wrap flex-column justify-content-center align-itens-center mr-3">
                                <span className="d-block font-weight-bold ">
                                    Ordem:
                                </span>
                                <span className="label label-light-dark  label-inline mr-2 my-1">
                                    {row.NR_ORDEM}
                                </span>
                            </div>
                            <div className="d-flex flex-wrap flex-column justify-content-center align-itens-center mr-3">
                                <span className="d-block font-weight-bold ">
                                    Tipo Ordenação:
                                </span>
                                <span className="label label-light-dark  label-inline mr-2 my-1">
                                    {row.FL_ORDEM_CRESCENTE
                                        ? "Ascendente"
                                        : "Descendente"}
                                </span>
                            </div>
                        </div>

                        <div className="d-flex flex-wrap">
                            <button
                                className="btn btn-light-danger border border-danger font-weight-bold m-1"
                                onClick={() => {
                                    Swal.fire({
                                        title: "Deseja apagar esta ordenação?",
                                        icon: "info",
                                        buttonsStyling: false,
                                        confirmButtonText:
                                            "<i class='la la-check'></i> Sim!",
                                        showCancelButton: true,
                                        cancelButtonText:
                                            "<i class='la la-thumbs-down'></i> Não",
                                        customClass: {
                                            confirmButton:
                                                "btn btn-outline-success",
                                            cancelButton: "btn btn-default",
                                        },
                                    }).then((result) => {
                                        if (result.isConfirmed) {
                                            row.ID_CASO_COBRANCA_REGUA_ETAPA_ORDENACAO &&
                                                DeletarOrdenacaoEtapaController(
                                                    row.ID_CASO_COBRANCA_REGUA_ETAPA_ORDENACAO
                                                ).then(() => {
                                                    updateList();
                                                });
                                        }
                                    });
                                }}
                            >
                                <FontAwesomeIcon icon={faTrash} size="sm" />
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        );
    };

    const columns: Array<ColumnDescription> = [
        {
            dataField: "ID_CASO_COBRANCA_REGUA_ETAPA_ORDENACAO",
            text: "",
            formatter: rowTable,
            headerClasses: "font-size-h8 font-weight-bold",
            classes: "p-3 ws-nowrap",
        },
    ];

    return (
        <div>
            <form onSubmit={handleSubmit(handleFormSubmit)} className="mb-3">
                <div className="d-flex flew-wrap col-md-12">
                    <div className="mt-2 p-1 col-md-4">
                        <h6>Tipo Filtro:</h6>
                        <select
                            name="DS_CAMPO"
                            className={`form-control placeholder-dark-45 ${
                                formState.errors.DS_CAMPO && "is-invalid"
                            }`}
                            ref={register({
                                required: "Insira o valor",
                                min: 0,
                            })}
                        >
                            <option></option>
                            <option value="DS_CLASSIFICACAO_CONTRATO">
                                Classificação do Contrato
                            </option>
                            <option value="NR_PARCELAS_EM_ABERTO">
                                Qt. Parcelas em Aberto
                            </option>
                            <option value="NR_AGING_DIAS_CONTRATO">
                                Aging
                            </option>
                            <option value="VL_PARCELAS_EM_ABERTO">
                                Vlr. Parcelas em Aberto
                            </option>
                            <option value="DATA_ULTIMO_CASO">
                                Dias Ult. Caso
                            </option>
                        </select>
                    </div>
                    <div className="mt-2 p-1 col-md-4">
                        <h6>Valor:</h6>
                        <input
                            type="number"
                            name="NR_ORDEM"
                            className={`form-control placeholder-dark-45 ${
                                formState.errors.NR_ORDEM && "is-invalid"
                            }`}
                            placeholder="Valor"
                            ref={register({
                                required: "Insira o valor",
                            })}
                        />
                    </div>

                    <div className="mt-2 p-1 col-md-4">
                        <h6>Tipo Ordenação:</h6>
                        <select
                            name="FL_ORDEM_CRESCENTE"
                            className={`form-control placeholder-dark-45 ${
                                formState.errors.FL_ORDEM_CRESCENTE &&
                                "is-invalid"
                            }`}
                            ref={register({
                                required: "Insira o valor",
                                valueAsNumber: true,
                            })}
                        >
                            <option></option>
                            <option value={1}>Ascendente</option>
                            <option value={0}>Descendente</option>
                        </select>
                    </div>
                </div>
                <div className="d-flex flew-column justify-content-end m-2">
                    <div className="d-flex flex-column justify-content-end mr-4">
                        <button className="btn btn-outline-success font-weight-bold d-flex justify-content-center align-items-center">
                            <FontAwesomeIcon
                                icon={faPlus}
                                size="lg"
                                className="mr-1"
                            />{" "}
                            Cadastrar
                        </button>
                    </div>
                </div>
            </form>

            <div>
                {LstOrdenacaoEtapa && (
                    <Table
                        columns={columns}
                        data={LstOrdenacaoEtapa}
                        keyField={"ID_CASO_COBRANCA_REGUA_ETAPA_ORDENACAO"}
                        bordered={false}
                        loading={Loading}
                    />
                )}
            </div>
        </div>
    );
}
